import { render, staticRenderFns } from "./NewsnEvents.vue?vue&type=template&id=1a4c48b8&"
import script from "./NewsnEvents.vue?vue&type=script&lang=js&"
export * from "./NewsnEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports